module.exports = __webpack_public_path__ + "media/images/icmje-banner-d3f391a57d2f5b2f5c3a67e958a28b40.png";